export default __webpack_public_path__ + "static/media/zayed-project-5.c72b1373.webp";